import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { sendResponse } from "../../../api";

const TicketResponse = () => {
  const [response, setResponse] = useState("");
  const location = useLocation();
  const navigate = useNavigate();
  const { ticket, customerName, customerEmail, customerPhone } =
    location.state || {};

  const handleSubmit = async () => {
    try {
      await sendResponse(ticket.ticket_id, customerEmail, response);
      alert("Response Submitted and Email Sent Successfully");
      setResponse("");
      navigate(-1);
    } catch (error) {
      console.error("Error submitting response:", error);
      alert("Failed to submit response. Please try again.");
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div style={{ margin: "50px", fontFamily: "Arial, sans-serif" }}>
      <h2 style={{ fontWeight: "bold" }}>Customer Ticket Details</h2>

      <div style={{ marginBottom: "20px" }}>
        <label
          htmlFor="response"
          style={{
            fontSize: "18px",
            display: "inline-block",
            marginBottom: "10px",
          }}
        >
          Response Description
        </label>
        <textarea
          id="response"
          value={response}
          onChange={(e) => setResponse(e.target.value)}
          style={{
            width: "100%",
            height: "150px",
            border: "1px solid #6495ED",
            borderRadius: "10px",
            padding: "10px",
            fontSize: "16px",
            outline: "none",
          }}
        />
      </div>

      <div style={{ display: "flex", gap: "10px" }}>
        <button
          onClick={handleSubmit}
          style={{
            backgroundColor: "#6495ED",
            color: "white",
            border: "none",
            borderRadius: "5px",
            padding: "10px 20px",
            fontSize: "16px",
            cursor: "pointer",
          }}
        >
          Submit Response
        </button>

        <button
          onClick={handleBack}
          style={{
            backgroundColor: "#6495ED",
            color: "white",
            border: "none",
            borderRadius: "5px",
            padding: "10px 20px",
            fontSize: "16px",
            cursor: "pointer",
          }}
        >
          Back
        </button>
      </div>
    </div>
  );
};

export default TicketResponse;
